export enum StatusType {
  published = 'published',
  draft = 'draft',
}
